module.exports = __webpack_public_path__ + "static/media/Bakeable Fillings.1cd18d3a.jpg";